import React, { useEffect, useState } from 'react';
import styles from './ToastNotification.module.css';

const ToastNotification = ({ message, type = 'success', duration = 3000 }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [renderToast, setRenderToast] = useState(false);

    useEffect(() => {
        if (message) {
            setRenderToast(true);
            const showTimer = setTimeout(() => {
                setIsVisible(true);
            }, 50);

            const hideTimer = setTimeout(() => {
                setIsVisible(false);
                setTimeout(() => {
                    setRenderToast(false);
                }, 300);
            }, duration + 50);

            return () => {
                clearTimeout(showTimer);
                clearTimeout(hideTimer);
            };
        } else {
            setIsVisible(false);
            setRenderToast(false);
        }
    }, [message, duration]);

    if (!renderToast) {
        return null;
    }

    return (
        <div className={`${styles.toastNotification} ${styles[type]} ${isVisible ? styles.isVisible : ''}`}>
            <div className={styles.toastHeader}>
                <span className={styles.toastTitle}>Уведомление</span>
            </div>
            <div className={styles.toastBody}>
                {message}
            </div>
        </div>
    );
};

export default ToastNotification;